import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
} from '@mui/material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import AlertDialog from 'Component/AlertDialog';
import { useSelector, useDispatch } from 'react-redux';
import {
  addEmployeesFromTable,
  setEmailConfig,
  removeEmployeesFromTable,
} from 'reducer/trainingSlice';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EmailModal from './EmailModal';
import EmailModalCollection from './EmailModalCollection';
import FormModal from 'Component/FormModal';
import AddEmployeeByIDForm from './AddEmployeeByIDForm';

const initialData = {
  left: ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6', 'Item 7', 'Item 8'],
  right: [],
};

const TraineeMapperDropBox = () => {
  const dispatch = useDispatch();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const stateValues = useSelector((state) => state.trainingSlice);
  const [data, setData] = useState(initialData);
  const [searchLeft, setSearchLeft] = useState('');
  const [searchRight, setSearchRight] = useState('');
  const {
    allAvailableTrainees,
    updating,
    batchTrainees,
    currentlyAssignedTrainees,
    emailConfig,
    loading,
    trainingType,
  } = stateValues;
  console.log('trainingType', trainingType);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const sourceList = result.source.droppableId;
    const destinationList = result.destination.droppableId;

    const sourceItems = sourceList === 'left' ? filteredLeft : filteredRight;
    const sourceDataKey = sourceList === 'left' ? 'left' : 'right';
    const destinationDataKey = destinationList === 'left' ? 'left' : 'right';

    const sourceData = Array.from(data[sourceDataKey]);
    const destinationData = Array.from(data[destinationDataKey]);

    const itemToMove = sourceItems[result.source.index];
    const itemIndexInSourceData = sourceData.indexOf(itemToMove);

    if (itemIndexInSourceData > -1) {
      sourceData.splice(itemIndexInSourceData, 1);
      destinationData.splice(result.destination.index, 0, itemToMove);

      setData({
        ...data,
        [sourceDataKey]: sourceData,
        [destinationDataKey]: destinationData,
      });
    }
  };

  useEffect(() => {
    // Create a new array with available trainees
    const availableTrainees = allAvailableTrainees
      .map((elem) => {
        const effectiveDate = elem.effectivePendingDate || elem.dateOfJoining;
        const [day, month, year] = effectiveDate.split('-').map(Number);
        const dateOfJoining = new Date(year, month - 1, day);

        return {
          displayString: `${elem.employeeId}/${elem.employeeName}/${elem.funcTitleName}/${effectiveDate}/${elem.nominationCount}`,
          nominationCount: elem.nominationCount,
          dateOfJoining: dateOfJoining,
          currentDate: new Date(),
        };
      })
      .sort((a, b) => {
        if (b.nominationCount !== a.nominationCount) {
          return b.nominationCount - a.nominationCount;
        }
        return a.dateOfJoining - b.dateOfJoining;
      })
      .map((item) => item.displayString);

    const availablecurrentlyAssignedTrainees = currentlyAssignedTrainees
      .map((elem) => {
        const effectiveDate = elem.effectivePendingDate || elem.dateOfJoining;
        const [day, month, year] = effectiveDate.split('-').map(Number);
        const dateOfJoining = new Date(year, month - 1, day);

        return {
          displayString: `${elem.employeeId}/${elem.employeeName}/${elem.funcTitleName}/${effectiveDate}/${elem.nominationCount}`,
          nominationCount: elem.nominationCount,
          dateOfJoining: dateOfJoining,
        };
      })
      .sort((a, b) => {
        if (b.nominationCount !== a.nominationCount) {
          return b.nominationCount - a.nominationCount;
        }
        return a.dateOfJoining - b.dateOfJoining;
      })
      .map((item) => item.displayString);

    setData((prevData) => ({
      ...prevData,
      left: availableTrainees,
      right: availablecurrentlyAssignedTrainees,
    }));
  }, [updating, allAvailableTrainees]);
  useEffect(() => {
    console.log('changing');
    const currentPeople = data.right.map((elem) => Number(elem.split('/')[0]));
    dispatch(addEmployeesFromTable(currentPeople));

    const currentPeopleLeft = data.left.map((elem) => Number(elem.split('/')[0]));
    dispatch(removeEmployeesFromTable(currentPeopleLeft));
  }, [data.right, dispatch]);

  const handleItemClick = (item, source, destination) => {
    console.log('item, source, destination,data', item, source, destination, data);
    const sourceItems = Array.from(data[source]);
    const destinationItems = Array.from(data[destination]);
    const itemIndex = sourceItems.indexOf(item);

    if (itemIndex > -1) {
      sourceItems.splice(itemIndex, 1);
      destinationItems.push(item);
      setData({
        ...data,
        [source]: sourceItems,
        [destination]: destinationItems,
      });
      const currentPeople = destinationItems.map((elem) => Number(elem.split('/')[0]));
      dispatch(addEmployeesFromTable(currentPeople));
      const currentPeopleLeft = sourceItems.map((elem) => Number(elem.split('/')[0]));
      dispatch(removeEmployeesFromTable(currentPeopleLeft));
    }
  };

  const handleSwap = () => {
    setData({ left: data.right, right: data.left });
    const currentPeople = data.left.map((elem) => Number(elem.split('/')[0]));
    dispatch(addEmployeesFromTable(currentPeople));

    const currentPeopleLeft = data.right.map((elem) => Number(elem.split('/')[0]));
    dispatch(removeEmployeesFromTable(currentPeopleLeft));
  };

  const filteredLeft = data.left.filter((item) =>
    item.toLowerCase().includes(searchLeft.toLowerCase())
  );
  const filteredRight = data.right.filter((item) =>
    item.toLowerCase().includes(searchRight.toLowerCase())
  );

  const handleEmailSubmit = (emailData) => {
    // Transform emailData into the required format based on training type
    let formattedEmailConfig;

    if (trainingType?.toLowerCase() === 'collection_training') {
      // For collection training, skip step 1 and adjust steps
      formattedEmailConfig = {
        totalSteps: 2,
        steps: [
          { to: emailData.stage1.to, cc: emailData.stage1.cc }, // Step 2 becomes Step 1
          { to: emailData.stage2.to, cc: emailData.stage2.cc }, // Step 3 becomes Step 2
        ],
      };
    } else {
      // For induction and other types, keep all 3 steps
      formattedEmailConfig = {
        totalSteps: 3,
        steps: [
          { to: emailData.stage1.to, cc: emailData.stage1.cc },
          { to: emailData.stage2.to, cc: emailData.stage2.cc },
          { to: emailData.stage3.to, cc: emailData.stage3.cc },
        ],
      };
    }

    dispatch(setEmailConfig(formattedEmailConfig));
    setShowEmailModal(false);
  };

  const isAlertDialogDisabled =
    !data.right.length || !emailConfig || !emailConfig.steps.every((step) => step.to.length > 0);

  const handleAddEmployees = (newEmployees) => {
    // check if the employee is already in the list
    let employeesToAdd = newEmployees.filter((elem) => !data.right.includes(elem));
    setData((prev) => ({
      ...prev,
      right: [...prev.right, ...employeesToAdd],
    }));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 2,
        p: 2,
      }}
    >
      {loading ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 600 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <AlertDialog disabled={isAlertDialogDisabled} />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mb: 2,
              width: '100%',
            }}
          >
            <FormModal
              buttonName="Add Employee by ID (Not Able to see someone?)"
              buttonVariant="contained"
              allowIcon={false}
              useSpan={true}
              width={'fit-content'}
              title="Add Employees by ID"
              form={<AddEmployeeByIDForm onSubmit={handleAddEmployees} />}
            />
            <Button
              variant="contained"
              onClick={() => setShowEmailModal(true)}
              disabled={!data.right.length}
              sx={{ minWidth: 150 }}
            >
              Configure Emails
            </Button>
          </Box>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3} alignItems="stretch">
                <Grid item xs={12} md={5}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: 600,
                    }}
                  >
                    <Typography variant="h6" align="center" sx={{ mb: 2 }}>
                      Available - {data.left.length}
                    </Typography>
                    <TextField
                      placeholder="Search"
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{ mb: 2 }}
                      value={searchLeft}
                      onChange={(e) => setSearchLeft(e.target.value)}
                    />
                    <Droppable droppableId="left">
                      {(provided) => (
                        <List
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          sx={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            border: '1px solid #ddd',
                            borderRadius: 1,
                            p: 1,
                          }}
                        >
                          {filteredLeft.map((item, index) => (
                            <Draggable key={item} draggableId={item} index={index}>
                              {(provided) => (
                                <ListItem
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  sx={{
                                    mb: 1,
                                    backgroundColor: (() => {
                                      const parts = item.split('/');
                                      const nominationCount = parseInt(parts[4]);
                                      const [day, month, year] = parts[3].split('-').map(Number);
                                      const dateOfJoining = new Date(year, month - 1, day);
                                      const currentDate = new Date();
                                      const daysDiff = Math.floor(
                                        (currentDate - dateOfJoining) / (1000 * 60 * 60 * 24)
                                      );
                                      if (nominationCount > 1 || daysDiff >= 15) {
                                        return '#ef9a9a';
                                      }
                                      return '#f5f5f5';
                                    })(),
                                    borderRadius: 1,
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                    '&:hover': {
                                      backgroundColor: '#e0e0e0',
                                    },
                                  }}
                                >
                                  <Tooltip title={item} placement="top" arrow>
                                    <ListItemText
                                      primary={item}
                                      sx={{
                                        '& .MuiTypography-root': {
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          fontSize: '0.75rem',
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                  <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => handleItemClick(item, 'left', 'right')}
                                    startIcon={<AddIcon />}
                                    sx={{ minWidth: 40 }}
                                  />
                                </ListItem>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </Paper>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={2}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                >
                  <IconButton
                    onClick={handleSwap}
                    color="primary"
                    sx={{
                      p: 2,
                      backgroundColor: 'primary.main',
                      color: 'white',
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                    }}
                  >
                    <SwapHorizIcon fontSize="large" />
                  </IconButton>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: 600,
                    }}
                  >
                    <Typography variant="h6" align="center" sx={{ mb: 2 }}>
                      Assigned - {data.right.length}
                    </Typography>
                    <TextField
                      placeholder="Search"
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{ mb: 2 }}
                      value={searchRight}
                      onChange={(e) => setSearchRight(e.target.value)}
                    />
                    <Droppable droppableId="right">
                      {(provided) => (
                        <List
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          sx={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            border: '1px solid #ddd',
                            borderRadius: 1,
                            p: 1,
                          }}
                        >
                          {filteredRight.map((item, index) => (
                            <Draggable key={item} draggableId={item} index={index}>
                              {(provided) => (
                                <ListItem
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  sx={{
                                    mb: 1,
                                    backgroundColor: (() => {
                                      const parts = item.split('/');
                                      const nominationCount = parseInt(parts[4]);
                                      const [day, month, year] = parts[3].split('-').map(Number);
                                      const dateOfJoining = new Date(year, month - 1, day);
                                      const currentDate = new Date();
                                      const daysDiff = Math.floor(
                                        (currentDate - dateOfJoining) / (1000 * 60 * 60 * 24)
                                      );
                                      if (nominationCount > 1 || daysDiff >= 15) {
                                        return '#ef9a9a';
                                      }
                                      return '#f5f5f5';
                                    })(),
                                    borderRadius: 1,
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                    '&:hover': {
                                      backgroundColor: '#e0e0e0',
                                    },
                                  }}
                                >
                                  <Tooltip title={item} placement="top" arrow>
                                    <ListItemText
                                      primary={item}
                                      sx={{
                                        '& .MuiTypography-root': {
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          fontSize: '0.75rem',
                                        },
                                      }}
                                    />
                                  </Tooltip>
                                  <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => handleItemClick(item, 'right', 'left')}
                                    startIcon={<RemoveIcon />}
                                    sx={{ minWidth: 40 }}
                                  />
                                </ListItem>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </List>
                      )}
                    </Droppable>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </DragDropContext>
          {trainingType?.toLowerCase() === 'collection_training' ? (
            <EmailModalCollection
              open={showEmailModal}
              onClose={() => setShowEmailModal(false)}
              onSubmit={handleEmailSubmit}
              initialEmailConfig={emailConfig}
            />
          ) : (
            <EmailModal
              open={showEmailModal}
              onClose={() => setShowEmailModal(false)}
              onSubmit={handleEmailSubmit}
              initialEmailConfig={emailConfig}
              trainingType={trainingType}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default TraineeMapperDropBox;
